import { render, staticRenderFns } from "./teacher-hour.vue?vue&type=template&id=17c1e7b1&scoped=true"
import script from "./teacher-hour.vue?vue&type=script&lang=js"
export * from "./teacher-hour.vue?vue&type=script&lang=js"
import style0 from "./teacher-hour.vue?vue&type=style&index=0&id=17c1e7b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1e7b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c1e7b1')) {
      api.createRecord('17c1e7b1', component.options)
    } else {
      api.reload('17c1e7b1', component.options)
    }
    module.hot.accept("./teacher-hour.vue?vue&type=template&id=17c1e7b1&scoped=true", function () {
      api.rerender('17c1e7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/teacher-hour.vue"
export default component.exports